module.exports = __webpack_public_path__ + "static/media/react.be7b83d4.svg";